import { AppHeartBeatService } from './app-heart-beat.service';
import { CommonService } from '../common.service';
var AppHeartBeatComponent = (function () {
    function AppHeartBeatComponent(commonService, heartBeatService) {
        this.commonService = commonService;
        this.heartBeatService = heartBeatService;
        this.heartBeatData = {}; //心跳传输对象
        //过滤协议列表
        this.filterHttpProtocolList = [
            'https:',
            'wss:',
            'file:',
            'chrome-extension:'
        ];
        this.heartBeatSourceData = {};
        this.isCamp = false;
    }
    AppHeartBeatComponent.prototype.ngOnInit = function () {
        this.isCamp = !!this.commonService.getStorage('skuId');
        this.url = this.heartBeatService.getEnvironmentsUrl(this.browserPlatformLocation['host']);
        this.heartBeatOnInit();
    };
    AppHeartBeatComponent.prototype.ngAfterViewInit = function () {
    };
    AppHeartBeatComponent.prototype.ngOnDestroy = function () {
        if (this.timer) {
            clearInterval(this.timer);
        }
    };
    // 心跳定时器逻辑
    // 获取心跳间隔
    // 先获取定位信息（过滤geolocationAPI拦截的不安全协议）
    // 设置参数
    // 根据心跳间隔保存心跳数据
    AppHeartBeatComponent.prototype.heartBeatOnInit = function () {
        var _this = this;
        var appId = this.heartBeatService.getEnvironmentsAppId(this.browserPlatformLocation['host']);
        this.heartBeatData.appId = appId;
        this.heartBeatService.getHeartBeatDuration(this.browserPlatformLocation['host'], appId, this.url).then(function (result) {
            _this.duration = result.appTimeInterval;
        }).then(function () {
            // this.heartBeatSourceData['geolocation'] = this.geolocation;
            _this.timer = setInterval(function () {
                // this.learningPathMetaId = $('#learningPathMetaIdContainer').val();
                // this.userId = $('#userIdContainer').val();
                // this.learningPathMetaId = $('#learningPathMetaIdContainer').val();
                // this.userId = $('#userIdContainer').val();
                _this.learningPathMetaId = _this.commonService.getStorage("learningPathMetaId");
                if (_this.isCamp) {
                    if (_this.commonService.getStorage("learningPathMetasId") && Number(_this.commonService.getStorage("learningPathMetasId")) !== 414) {
                        //互联网day1心跳learningPathMetaId先不改变
                        _this.learningPathMetaId = Number(_this.commonService.getStorage("learningPathMetasId"));
                    }
                }
                _this.userId = $('#userIdContainer').val() ? $('#userIdContainer').val() : _this.commonService.getStorage('userId') ? _this.commonService.getStorage('userId') : '';
                _this.heartBeatSourceData['userId'] = _this.userId;
                _this.heartBeatSourceData['learningPathMetaId'] = _this.learningPathMetaId;
                _this.heartBeatSourceData['pathname'] = _this.browserPlatformLocation['pathname'];
                _this.heartBeatSourceData['moduleId'] = _this.commonService.getStorage('moduleId') ? Number(_this.commonService.getStorage('moduleId')) : null;
                _this.heartBeatService.setHeartBeatValue(_this.heartBeatData, _this.heartBeatSourceData);
                _this.heartBeatService.saveHeartBeatValue(_this.browserPlatformLocation['host'], _this.heartBeatData, _this.url).subscribe();
            }, _this.duration * 1000);
        });
    };
    return AppHeartBeatComponent;
}());
export { AppHeartBeatComponent };



// WEBPACK FOOTER //
// ./src/app/app-heart-beat/app-heart-beat.component.ts.pre-build-optimizer.js